import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

import './Radiobutton.less';

export default class Radiobutton extends React.Component {
    static displayName = 'Assets.Input.Radiobutton';
    static propTypes = {
        id: PropTypes.string,
        name: PropTypes.string.isRequired,
        label: PropTypes.oneOfType([
            PropTypes.element,
            PropTypes.string
        ]),
        value: PropTypes.oneOfType([
            PropTypes.number,
            PropTypes.string
        ]),
        className: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.array,
            PropTypes.object
        ]),
        pill: PropTypes.bool,
        checked: PropTypes.bool,
        onChange: PropTypes.func,
        /**
         * Not used when "pill" is true
         */
        description: PropTypes.oneOfType([
            PropTypes.element,
            PropTypes.string
        ])
    };
    static defaultProps = {
        id: '',
        name: '',
        label: null,
        value: '',
        className: '',
        pill: false,
        checked: false,
        onChange: () => {},
        description: ''
    };

    /**
     *
     * @param {Object} props Props
     */
    constructor(props) {
        super(props);
    }

    /**
     *
     * @returns {XML} Component
     */
    render() {
        var baseClass = this.props.pill ? 'settings-radio-button-pill' : 'settings-radio-button';
        var classes = classnames(baseClass, this.props.className);
        var description = !this.props.pill && this.props.description ? <small className="settings-radio-button__description">{this.props.description}</small> : null;
        return (
            <label className={classes} id={this.props.id}>
                <input
                    className={baseClass + '__input'}
                    type="radio"
                    name={this.props.name}
                    value={this.props.value}
                    defaultChecked={this.props.checked}
                    onClick={this.props.onChange} />
                <span className={baseClass + '__label'}>
                    {this.props.label}
                </span>
                {description}
            </label>
        );
    }
}



// WEBPACK FOOTER //
// ./src/UserSettings/components/Input/Radiobutton/index.jsx